// @ts-check
import { route } from './author.js';
export const MEMORY_LEVELS = [
  route(3, 1, 'Fresh Allocation', 'Memory cells expire after contact. The shrinking meter shows your time.', 142)
    .node(9).device('memory', 16, 1, 4, 0.5, 5).device('memory', 24, 2, 4, 0.5, 5)
    .node(30, 4, 'bit', 'bank').bot(35).gap(40, 3).checkpoint(47, 'Stable address')
    .device('memory', 54, 1, 4, 0.5, 4.5).device('memory', 61, 3, 4, 0.5, 4.5)
    .device('memory', 68, 4, 4, 0.5, 4.5).node(72, 6, 'overclock').bot(78, 0, true)
    .checkpoint(88, 'Allocation desk').node(94).gap(102, 6).device('memory', 102, 0, 3, 0.5, 4.5)
    .device('memory', 105, 0, 3, 0.5, 4.5).platform(113, 1, 4, 0.5).bot(122).stairs(131, 3).build(),
  route(3, 2, 'Cache Miss', 'Refill nodes restore linked memory. Solid pads are safe places to plan.', 156)
    .node(9, 3, 'upgrade', 'cache').device('memory', 17, 2, 4, 0.5, 4, { group: 'cache' })
    .device('memory', 24, 3, 4, 0.5, 4, { group: 'cache' }).node(32, 3, 'bit', 'cache')
    .gap(39, 3).bot(44).checkpoint(50, 'Cache anchor').node(56, 3, 'bit', 'refill')
    .gap(63, 8).device('memory', 63, 0, 4, 0.5, 4, { group: 'refill' }).device('memory', 67, 0, 4, 0.5, 4, { group: 'refill' })
    .platform(77, 2, 4, 0.5).node(82).bot(89, 0, true).checkpoint(97, 'Reserved page')
    .device('memory', 105, 1, 3, 0.5, 3.5).device('memory', 112, 3, 3, 0.5, 3.5)
    .device('memory', 120, 4, 3, 0.5, 3.5).node(123, 6, 'overclock').gap(131, 3).bot(142).build(),
  route(3, 3, 'Garbage Collection', 'Move through the reclaim sequence. Refill nodes rebuild your return route.', 160)
    .node(9).device('memory', 16, 1, 3, 0.5, 3.5).device('memory', 23, 2, 3, 0.5, 3.5)
    .device('scanner', 29, 0, 8, 0.6, 5).platform(35, 0, 1, 1).checkpoint(44, 'Reclaim boundary')
    .node(50, 3, 'bit', 'restore').gap(58, 10)
    .device('memory', 58, 0, 3, 0.5, 3.5, { group: 'restore' }).device('memory', 61, 1, 3, 0.5, 3.5, { group: 'restore' })
    .device('memory', 65, 0, 3, 0.5, 3.5, { group: 'restore' }).node(73, 3, 'bit', 'restore')
    .bot(81).node(88).checkpoint(96, 'Retained page').device('scanner', 103, 0, 10, 0.6, 5)
    .platform(109, 0, 1, 1).device('memory', 117, 2, 4, 0.5, 3.5).device('memory', 125, 4, 4, 0.5, 3.5)
    .node(130, 6, 'overclock').gap(138, 3).bot(147, 0, true).build(),
  route(3, 4, 'Reclaim Queue', 'Watch the reclaim strips. Jump the sweep and strike the exposed cap.', 110)
    .node(9).device('memory', 17, 1, 4, 0.5, 4).device('memory', 25, 3, 4, 0.5, 4)
    .gap(35, 5).device('memory', 35, 0, 5, 0.5, 4).node(47, 3, 'bit', 'restore')
    .device('scanner', 54, 0, 8, 0.6, 5).platform(60, 0, 1, 1).node(68)
    .boss('reclaimer', 'Reclaimer').build(),
];
